import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { AspectRatioComponent } from './aspect-ratio/aspect-ratio.component';
import { ImageShellComponent } from './image-shell/image-shell.component';
import { TextShellComponent } from './text-shell/text-shell.component';
import { TransferStateHelper } from 'src/app/utils/transfer-state-helper';
import { ShowHidePasswordComponent } from 'src/app/components/show-hide-password/show-hide-password.component';

@NgModule({
  declarations: [
    AspectRatioComponent,
    ImageShellComponent,
    TextShellComponent,
    ShowHidePasswordComponent
  ],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [
    AspectRatioComponent,
    ImageShellComponent,
    TextShellComponent,
    ShowHidePasswordComponent
  ],
  providers: [
    TransferStateHelper
  ]
})
export class ShellModule { }
